module.exports = __webpack_public_path__ + "static/img/rongyu5.6cb4cf2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rongyu5.jpg
// module id = j3pF
// module chunks = 1